"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StripeForm = exports.StripeProvider = exports.useStripeContext = void 0;
const react_1 = __importStar(require("react"));
const stripe_js_1 = require("@stripe/stripe-js");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const StripeContext = (0, react_1.createContext)({});
const useStripeContext = () => (0, react_1.useContext)(StripeContext);
exports.useStripeContext = useStripeContext;
const StripeProvider = ({ stripeKey, children }) => {
    const stripeLoader = (0, react_1.useRef)((0, stripe_js_1.loadStripe)(stripeKey)); // to avoid re-rendering
    return (react_1.default.createElement(StripeContext.Provider, { value: { stripeLoader: stripeLoader.current } }, children));
};
exports.StripeProvider = StripeProvider;
const StripeForm = ({ children }) => {
    const { stripeLoader } = (0, exports.useStripeContext)();
    if (!stripeLoader) {
        return null;
    }
    return react_1.default.createElement(react_stripe_js_1.Elements, { stripe: stripeLoader }, children);
};
exports.StripeForm = StripeForm;
